import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { change } from 'redux-form';
import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { all, call, put, spawn } from 'redux-saga/effects';
import { defineMessages } from 'react-intl';
import { planById } from 'redux/saga/entities/bound';
import { msaIdToAlias } from 'constants/msas';
import { createUserAndLogIn } from 'features/Login/Authentication.saga';
import { signup } from 'features/Signup/FormAction';
import { ga } from 'helpers/multitrack';
import { trackGoogleTagManagerEvent } from 'components/GoogleTagManager/GoogleTagManager';
import { addCartItem, emptyCart } from 'redux/modules/cart';
import { BaseProduct } from './BaseProduct';
export var messages = defineMessages({
  monthlySubscription: {
    id: 'signup.planProduct.monthlySubscription',
    defaultMessage: 'Monthly subscription'
  }
});
export var PlanProduct =
/*#__PURE__*/
function (_BaseProduct) {
  _inherits(PlanProduct, _BaseProduct);

  function PlanProduct() {
    _classCallCheck(this, PlanProduct);

    return _possibleConstructorReturn(this, _getPrototypeOf(PlanProduct).apply(this, arguments));
  }

  _createClass(PlanProduct, null, [{
    key: "loadSignupData",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function loadSignupData(client) {
      var _ref, planId, plan;

      return regeneratorRuntime.wrap(function loadSignupData$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(PlanProduct.getProductData);

            case 2:
              _ref = _context.sent;
              planId = _ref.planId;
              _context.next = 6;
              return call(fetchEntityIfNeeded, planById, [client, planId]);

            case 6:
              plan = _context.sent;
              _context.next = 9;
              return spawn(trackGoogleTagManagerEvent, {
                msaId: plan.msa_id,
                msaName: msaIdToAlias(plan.msa_id)
              });

            case 9:
              _context.next = 11;
              return put(change('signup', 'planId', planId));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, loadSignupData);
    })
  }, {
    key: "submitSignupData",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function submitSignupData(client, basePayload) {
      var _ref2, planId;

      return regeneratorRuntime.wrap(function submitSignupData$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return call(PlanProduct.getProductData);

            case 2:
              _ref2 = _context2.sent;
              planId = _ref2.planId;
              _context2.next = 6;
              return call(createUserAndLogIn, client, signup, _objectSpread({}, basePayload, {
                plan_id: planId
              }));

            case 6:
              return _context2.abrupt("return", _context2.sent);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, submitSignupData);
    })
  }, {
    key: "loadPurchaseData",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function loadPurchaseData(client) {
      var _ref3, planId, plan;

      return regeneratorRuntime.wrap(function loadPurchaseData$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return call(PlanProduct.getProductData);

            case 2:
              _ref3 = _context3.sent;
              planId = _ref3.planId;
              _context3.next = 6;
              return call(fetchEntityIfNeeded, planById, [client, planId]);

            case 6:
              plan = _context3.sent;
              _context3.next = 9;
              return all([put(change('purchase', 'planId', plan.id)), put(change('purchase', 'msaId', plan.msa_id)), put(emptyCart()), put(addCartItem('plan', messages.monthlySubscription, plan.price, {
                planCode: plan.plan_code,
                isTaxable: true
              }))]);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, loadPurchaseData);
    })
  }, {
    key: "trackPurchaseFailure",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackPurchaseFailure() {
      var _ref4, planId;

      return regeneratorRuntime.wrap(function trackPurchaseFailure$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return call(PlanProduct.getProductData);

            case 2:
              _ref4 = _context4.sent;
              planId = _ref4.planId;
              _context4.next = 6;
              return spawn(ga, 'Membership Purchase', 'Membership Purchase Errors', "plan-".concat(planId));

            case 6:
            case "end":
              return _context4.stop();
          }
        }
      }, trackPurchaseFailure);
    })
  }, {
    key: "trackPurchaseSuccess",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackPurchaseSuccess(result) {
      var _ref5, planId;

      return regeneratorRuntime.wrap(function trackPurchaseSuccess$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(PlanProduct.getProductData);

            case 2:
              _ref5 = _context5.sent;
              planId = _ref5.planId;
              _context5.next = 6;
              return call(BaseProduct.trackPurchaseSuccess, result);

            case 6:
              _context5.next = 8;
              return spawn(ga, 'Membership Purchase', 'Checkout Success', "plan-".concat(planId));

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, trackPurchaseSuccess);
    })
  }, {
    key: "trackSignupFailure",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackSignupFailure() {
      var _ref6, planId;

      return regeneratorRuntime.wrap(function trackSignupFailure$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(PlanProduct.getProductData);

            case 2:
              _ref6 = _context6.sent;
              planId = _ref6.planId;
              _context6.next = 6;
              return spawn(ga, 'Membership Purchase', 'Create Account Error', "plan-".concat(planId));

            case 6:
            case "end":
              return _context6.stop();
          }
        }
      }, trackSignupFailure);
    })
  }, {
    key: "trackSignupSuccess",
    value:
    /*#__PURE__*/
    regeneratorRuntime.mark(function trackSignupSuccess() {
      var _ref7, planId;

      return regeneratorRuntime.wrap(function trackSignupSuccess$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return call(PlanProduct.getProductData);

            case 2:
              _ref7 = _context7.sent;
              planId = _ref7.planId;
              _context7.next = 6;
              return spawn(ga, 'Membership Purchase', 'Create Account Success', "plan-".concat(planId));

            case 6:
            case "end":
              return _context7.stop();
          }
        }
      }, trackSignupSuccess);
    })
  }]);

  return PlanProduct;
}(BaseProduct);

_defineProperty(PlanProduct, "key", 'PlanProduct');